import React from "react";
import { Search, Filter } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const FiltersBar = ({
  filters,
  setFilters,
  showFilters,
  setShowFilters,
  handleSearch,
  applyFilters,
  clearFilters,
}) => {
  return (
    <div className="sticky top-20 z-30 bg-[#0A0A0A] border-b border-[#2A2A2A] py-3 sm:py-4 px-4 sm:px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-3 md:gap-4 md:items-center">
          <form onSubmit={handleSearch} className="relative flex-1 max-w-md">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-500" />
            <Input
              placeholder="Search gigs, promoters..."
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              className="pl-12 h-12 bg-[#141414] border-[#2A2A2A] text-white placeholder:text-zinc-500"
              data-testid="search-input"
            />
          </form>
          <div className="flex gap-3 flex-wrap items-center">
            <Select
              value={filters.platform}
              onValueChange={(value) => setFilters({ ...filters, platform: value })}
            >
              <SelectTrigger className="w-40 h-12 bg-[#141414] border-[#2A2A2A] text-white" data-testid="platform-filter">
                <Filter className="w-4 h-4 mr-2" />
                <SelectValue placeholder="Platform" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Platforms</SelectItem>
                <SelectItem value="tiktok">TikTok</SelectItem>
                <SelectItem value="meta">Meta</SelectItem>
                <SelectItem value="spotify">Spotify</SelectItem>
              </SelectContent>
            </Select>

            <Select
              value={filters.sortBy}
              onValueChange={(value) => setFilters({ ...filters, sortBy: value })}
            >
              <SelectTrigger className="w-40 h-12" data-testid="sort-filter">
                <SelectValue placeholder="Sort by" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="newest">Newest</SelectItem>
                <SelectItem value="price_asc">Price: Low to High</SelectItem>
                <SelectItem value="price_desc">Price: High to Low</SelectItem>
                <SelectItem value="followers">Most Followers</SelectItem>
                <SelectItem value="popular">Most Popular</SelectItem>
              </SelectContent>
            </Select>

            <Button
              variant="outline"
              onClick={() => setShowFilters(!showFilters)}
              className="h-12 px-4 bg-[#1A1A1A] border-[#2A2A2A] text-white hover:bg-[#2A2A2A] hover:text-white"
              data-testid="more-filters-btn"
            >
              More Filters
            </Button>
          </div>
        </div>

        {showFilters && (
          <div className="mt-4 p-4 border border-[#2A2A2A] bg-[#141414] animate-fade-in-up">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <label className="text-xs font-medium text-zinc-400 mb-1 block">Min Price ($)</label>
                <Input
                  type="number"
                  placeholder="0"
                  value={filters.minPrice}
                  onChange={(e) => setFilters({ ...filters, minPrice: e.target.value })}
                  className="h-10 bg-[#1A1A1A] border-[#2A2A2A] text-white"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-zinc-400 mb-1 block">Max Price ($)</label>
                <Input
                  type="number"
                  placeholder="1000"
                  value={filters.maxPrice}
                  onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })}
                  className="h-10 bg-[#1A1A1A] border-[#2A2A2A] text-white"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-zinc-400 mb-1 block">Min Followers</label>
                <Input
                  type="number"
                  placeholder="10000"
                  value={filters.minFollowers}
                  onChange={(e) => setFilters({ ...filters, minFollowers: e.target.value })}
                  className="h-10 bg-[#1A1A1A] border-[#2A2A2A] text-white"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-zinc-400 mb-1 block">Max Delivery (days)</label>
                <Input
                  type="number"
                  placeholder="7"
                  value={filters.maxDelivery}
                  onChange={(e) => setFilters({ ...filters, maxDelivery: e.target.value })}
                  className="h-10 bg-[#1A1A1A] border-[#2A2A2A] text-white"
                />
              </div>
            </div>
            <div className="flex gap-2 mt-4">
              <Button onClick={applyFilters} className="btn-primary">
                Apply Filters
              </Button>
              <Button
                variant="outline"
                onClick={clearFilters}
                className="bg-transparent border-[#2A2A2A] text-white hover:bg-[#1A1A1A] hover:text-white"
              >
                Clear All
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FiltersBar;
